module.exports = __webpack_public_path__ + "img/hero-pm.5f7878a9.png";